export const missionChapters = [
  { id: 'home', number: '01', label: 'Launch', navLabel: 'Home' },
  { id: 'skills', number: '02', label: 'Systems', navLabel: 'Skills' },
  { id: 'projects', number: '03', label: 'Launchpad', navLabel: 'Projects' },
  { id: 'open-source', number: '04', label: 'Open Source', navLabel: 'Open Source' },
  { id: 'testimonials', number: '05', label: 'Signals', navLabel: 'Testimonials' },
  { id: 'connect', number: '06', label: 'Contact', navLabel: 'Connect' },
];

export const missionStats = [
  { value: '4', label: 'Years Experience' },
  { value: '100+', label: 'Projects & Features' },
  { value: '10+', label: 'Technologies' },
  { value: '\u221e', label: 'Curiosity', ariaLabel: 'Infinite Curiosity' },
];
